/**
=========================================================
* Material Dashboard 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from '@mui/material/Card'
import Icon from '@mui/material/Icon'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

// Material Dashboard 2 PRO React example components
import TimelineItem from 'components/Timeline/TimelineItem'

function OrdersOverview () {
  return (
    <Card sx={{ height: '100%' }}>
      <MDBox pt={3} px={3}>
        <MDTypography variant='h6' fontWeight='medium'>
          نظرة عامة على الطلبات
        </MDTypography>
        <MDBox mt={0} mb={2}>
          <MDTypography variant='button' color='text' fontWeight='regular'>
            <MDTypography display='inline' variant='body2' verticalAlign='middle'>
              <Icon sx={{ color: ({ palette: { success } }) => success.main }}>arrow_upward</Icon>
            </MDTypography>
            &nbsp;
            <MDTypography variant='button' color='text' fontWeight='medium'>
              24%
            </MDTypography>{' '}
            هذا الشهر
          </MDTypography>
        </MDBox>
      </MDBox>
      <MDBox p={2}>
        <TimelineItem
          color='success'
          icon='notifications'
          title='$2400, تغييرات في التصميم'
          dateTime='22 ديسمبر 7:20 مساءً'
        />
        <TimelineItem
          color='error'
          icon='inventory_2'
          title='طلب جديد # 1832412'
          dateTime='21 ديسمبر 11 م'
        />
        <TimelineItem
          color='info'
          icon='shopping_cart'
          title='مدفوعات الخادم لشهر أبريل'
          dateTime='21 ديسمبر 9:34 مساءً'
        />
        <TimelineItem
          color='warning'
          icon='payment'
          title='تمت إضافة بطاقة جديدة للأمر رقم 4395133'
          dateTime='20 ديسمبر 2:20 صباحًا'
        />
        <TimelineItem
          color='primary'
          icon='vpn_key'
          title='فتح الحزم من أجل التطوير'
          dateTime='18 ديسمبر ، 4:54 صباحًا'
          lastItem
        />
      </MDBox>
    </Card>
  )
}

export default OrdersOverview
